(ns hypnos.backoffice.tile.field.patient-communication-preferences
  "Field for patient communication preferences."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.has-check.is-horizontal
    [:div.field-label.is-normal
     [:label.label (str (tr :ui.label/comm-preferences))]]
    [:div.field-body
     [:div.field.is-grouped-multiline.is-grouped
      [:div.control
       [:label.b-checkbox.checkbox
        [:input
         {:id        :communication-preference-sms
          :name      :communication-preference-sms
          :type      :checkbox
          :disabled  disabled
          :checked   (contains? (get-in @state [:patient :patient/communication-preferences :value])
                                :communication-channel/sms)
          :on-change (fn [e]
                       (let [comm-prefs (get-in @state [:patient :patient/communication-preferences :value])
                             old-value  (contains? comm-prefs :communication-channel/sms)
                             new-value  (-> e .-target .-checked)
                             changed?   (or (get-in @state
                                                    [:patient :patient/communication-preferences :dirty?])
                                            (not= new-value old-value))]
                         (if (and changed? new-value)
                           (swap! state update-in
                                  [:patient :patient/communication-preferences :value]
                                  conj :communication-channel/sms)
                           (swap! state update-in
                                  [:patient :patient/communication-preferences :value]
                                  disj :communication-channel/sms))
                         (swap! state assoc-in
                                [:patient :patient/communication-preferences :dirty?]
                                changed?)))
          :on-focus  (fn [_] (swap! state assoc-in
                                    [:patient :patient/communication-preferences :touched?]
                                    true))}]
        [:span.check.is-info]
        [:span.control-label (tr :ui.communication-preference/sms)]]]
      #_[:div.control
       [:label.b-checkbox.checkbox
        [:input
         {:id        :communication-preference-email
          :name      :communication-preference-email
          :type      :checkbox
          :disabled  disabled
          :checked   (contains? (get-in @state [:patient :patient/communication-preferences :value])
                                :communication-channel/email)
          :on-change (fn [e]
                       (let [comm-prefs (get-in @state [:patient :patient/communication-preferences :value])
                             old-value  (contains? comm-prefs :communication-channel/email)
                             new-value  (-> e .-target .-checked)
                             changed?   (or (get-in @state [:patient :patient/communication-preferences :dirty?])
                                            (not= new-value old-value))]
                         (if (and changed? new-value)
                           (swap! state update-in
                                  [:patient :patient/communication-preferences :value]
                                  conj :communication-channel/email)
                           (swap! state update-in
                                  [:patient :patient/communication-preferences :value]
                                  disj :communication-channel/email))
                         (swap! state assoc-in
                                [:patient :patient/communication-preferences :dirty?]
                                changed?)))
          :on-focus  (fn [_] (swap! state assoc-in
                                    [:patient :patient/communication-preferences :touched?]
                                    true))}]
        [:span.check.is-info]
        [:span.control-label (tr :ui.communication-preference/email)]]]]]]))
